import React from 'react';
import { Instructor } from '../../data/instructors';
interface InstructorCardProps {
  instructor: Instructor;
}
export function InstructorCard({
  instructor
}: InstructorCardProps) {
  return <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-391">
      <div className="aspect-[3/4] overflow-hidden bg-slate-100" data-id="element-392">
        <img src={instructor.image} alt={instructor.name} className="w-full h-full object-cover object-center" data-id="element-393" />
      </div>

      <div className="p-6 text-center" data-id="element-394">
        <h3 className="text-xl font-bold text-[#1a2332] mb-2" data-id="element-395">
          {instructor.name}
        </h3>
        <p className="text-sm text-slate-600" data-id="element-396">{instructor.role}</p>
      </div>
    </div>;
}